module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-all-400-normal.woff?c5d001fa922fa66a147f5f3aea5ef30e";